export const CREDIT_PRICE_PER_MEETING_OPTIONS = [
  {},
  { priceCreditsPerMeetingMax: 20 },
  { priceCreditsPerMeetingMax: 40 },
  { priceCreditsPerMeetingMax: 60 },
  { priceCreditsPerMeetingMax: 80 },
  { priceCreditsPerMeetingMin: 80 },
];

export const CREDIT_PRICE_PER_COURSE_OPTIONS = [
  {},
  { priceCreditsPerCourseMax: 100 },
  { priceCreditsPerCourseMax: 300 },
  { priceCreditsPerCourseMax: 500 },
  { priceCreditsPerCourseMax: 700 },
  { priceCreditsPerCourseMin: 700 },
];

export type CreditOptionType = {
  priceCreditsPerMeetingMax?: number;
  priceCreditsPerMeetingMin?: number;
  priceCreditsPerCourseMax?: number;
  priceCreditsPerCourseMin?: number;
};
